import React, { useState } from 'react';
import Modal from '@/components/Modal';
import Funnel from '@/assets/media/SVGComponents/Funnel';

const FilterComponent = ({ filterOptions, onApplyFilters }) => {
	const [filters, setFilters] = useState({});
	const [showModal, setShowModal] = useState(false);

	// Gestion du changement de valeur des filtres
	const handleFilterChange = (field, value) => {
		setFilters((prevFilters) => ({
			...prevFilters,
			[field]: value,
		}));
	};

	// Application des filtres
	const applyFilters = () => {
		onApplyFilters(filters);
		setShowModal(false); // Fermer le modal après l'application des filtres
	};

	// Réinitialisation des filtres
	const resetFilters = () => {
		setFilters({});
		onApplyFilters({});
	};

	return (
		<>
			<button onClick={() => setShowModal(true)}>
				<Funnel></Funnel>
			</button>

			{showModal && (
				<Modal
					title="Filtres"
					setShowModal={setShowModal}
					handleSubmit={applyFilters}
					type="info"
					showFooterButtons={false}
					customButtons={
						<>
							<div className="flex gap-2 mt-4">
								<button
									onClick={resetFilters}
									className="transition duration-300 bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-500/80"
								>
									Réinitialiser
								</button>
								<button
									onClick={applyFilters}
									className="transition duration-300 bg-primary text-white py-2 px-4 rounded-md hover:bg-primary/80"
								>
									Appliquer
								</button>
							</div>
						</>
					}
				>
					<div className="filter-component p-4">
						{filterOptions.map((option) => (
							<div key={option.field} className="mb-4">
								<label className="block text-sm font-medium mb-2">{option.label}</label>
								{option.type === 'select' && (
									<select
										value={filters[option.field] || ''}
										onChange={(e) => handleFilterChange(option.field, e.target.value)}
										className="p-2 border border-gray-300 rounded-md w-full"
									>
										{option.options.map((opt) => (
											<option key={opt.value} value={opt.value}>
												{opt.label}
											</option>
										))}
									</select>
								)}
								{option.type === 'date-range' && (
									<div className="flex gap-2">
										<input
											type="date"
											value={filters[`${option.field}_start`] || ''}
											onChange={(e) => handleFilterChange(`${option.field}_start`, e.target.value)}
											className="p-2 border border-gray-300 rounded-md w-full"
											placeholder="Date de début"
										/>
										<input
											type="date"
											value={filters[`${option.field}_end`] || ''}
											onChange={(e) => handleFilterChange(`${option.field}_end`, e.target.value)}
											className="p-2 border border-gray-300 rounded-md w-full"
											placeholder="Date de fin"
										/>
									</div>
								)}
							</div>
						))}
					</div>
				</Modal>
			)}
		</>
	);
};

export default FilterComponent;
